



























import { Component, Vue, Watch } from 'vue-property-decorator'
import { State, Action, Getter, Mutation } from 'vuex-class'
import _get from 'lodash/get'
import { AuthState } from '@/store/auth/types'
import FranklinMedia from '@/components/FranklinMedia.vue'
import SearchInput from '@/components/SearchInput.vue'
import UploadInventoryList from '@/components/UploadInventoryList.vue'
import { SEARCH_TYPE } from '@/types'
import { isValidISBN, normalizeISBN } from '@/utils/isbn.util'

const namespace: string = 'auth'

@Component({
  components: {
    FranklinMedia,
    SearchInput,
    UploadInventoryList,
  },
})
export default class Home extends Vue {
  private helperText: string = 'Scan or enter an ISBN to get started.'
  private searchType: string = SEARCH_TYPE.BOOK_SEARCH_BY_ISBN

  @Mutation('setSearchKeyword', { namespace: 'books' }) private setSearchKeyword: any

  private mounted(): void {}

  private onSubmit(keyword: string): void {
    const normalizedISBN: string = normalizeISBN(keyword)
    if (!isValidISBN(normalizedISBN)) {
      Vue.$toast.error('Please enter a valid ISBN to search.')
      return
    }

    this.setSearchKeyword(normalizedISBN)
    this.$router.push({ name: 'BookSearchByISBN' })
  }

  private handleUploadingInventoryList(): void {}

  private handleSuccessUploadInventoryList(offerId: string): void {}

  private handleFailedUploadInventoryList(): void {
    Vue.$toast.error('Upload Inventory List Failed. Please try again.')
  }
}
